const DEVICE_SOURCE_KEY = 'device-source';

const getDefaultDeviceType = () => {
  if (!window) return 'desktop';

  const userAgent = window.navigator.userAgent.toLowerCase();
  const isMobile =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  return isMobile ? 'mobile' : 'desktop';
};

// Client-side functions

export const getDeviceSource = () => {
  if (!window) return 'desktop';

  try {
    return sessionStorage.getItem(DEVICE_SOURCE_KEY) || getDefaultDeviceType();
  } catch (e) {
    console.warn('Could not access sessionStorage:', e);
    return getDefaultDeviceType();
  }
};

export const setDeviceSource = () => {
  if (!window) return;

  const urlParams = new URLSearchParams(window.location.search);
  const device = urlParams.get('device');

  try {
    sessionStorage.setItem(
      DEVICE_SOURCE_KEY,
      device ?? getDeviceSource()
    );
  } catch (e) {
    console.warn('Could not access sessionStorage:', e);
  }
};
